const ZoneCapacityBar = new URL('../../icons/zone-capacity-bar.png', import.meta.url).href

export default {
  type: 'ZoneCapacityBar',
  description: 'ZoneCapacityBar',
  icon: ZoneCapacityBar,
  group: 'SCS',
  model: {
    type: 'ZoneCapacityBar',
    left: 100,
    top: 100,
    width: 200,
    height: 60,
    maxCapacity: 100,
    highWatermark: 100,
    currentUsage: 0,
    round: 30
  }
}
